import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\classes\\[id]\\ClassDetailClient.tsx");
